import { POSTERS } from './posters';
import { CONTEXT } from './tagging';

export function isRelevantFATMessage<E extends Entity>(
  event: MessageEvent<unknown>,
  entity: E,
): event is MessageEvent<TaggedMessage<E>> {
  const allowedSendersForEntity = POSTERS[entity];

  return (
    // Message is an object
    !!event?.data &&
    typeof event.data === 'object' &&
    // and it has the right context
    'context' in event.data &&
    event.data.context === CONTEXT &&
    // and it is addressed to the right entity
    'to' in event.data &&
    event.data.to === entity &&
    // and it is from an allowed sender
    'from' in event.data &&
    typeof event.data.from === 'string' &&
    event.data.from in allowedSendersForEntity
  );
}
